import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSearchParams, getRevDate, fetchGet } from '../../common/common';
import { getSearchResults } from '../../actions/search-actions';

import store from '../../store';


// /api/resource/getCities
// /api/resource/searchRoutes?fromCityID=14&toCityID=198&journeyDate=2018-02-16
// /api/resource/seatArrangement?routeID=27946~43735~14~198~2018-02-16&journeyDate=2018-02-16
// /api/resource/getRouteInfo?routeID=27946~43735~14~198~2018-02-16

import Modify from '../modify/modify';
import Sort from '../sort/sort';
import Listing from '../listing/listing';

import './search.css';

let srchPrm = '';

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true
        }
    }

    componentWillMount() {
        srchPrm = getSearchParams();
    }

    componentDidMount() {
        // const that = this;
        const url = window.url + '/api/resource/searchRoutes?fromCityID=' + srchPrm.fromCity.split('|')[0] + '&toCityID=' + srchPrm.toCity.split('|')[0] + '&fromCityName=' + srchPrm.fromCity.split('|')[1] + '&toCityName=' + srchPrm.toCity.split('|')[1] + '&journeyDate=' + getRevDate(srchPrm.departDate) + '&mode=' + srchPrm.mode;
        // const url = window.url + '/api/resource/searchRoutes?fromCityID=14&toCityID=198&journeyDate=2018-02-18';
        fetchGet(url).then(function(data) {
            data = data.sort((a,b) => {return (a.DepartureTime > b.DepartureTime) ? 1 : ((b.DepartureTime > a.DepartureTime) ? -1 : 0)});
            store.dispatch(getSearchResults(data));
        }).catch(function(error) {
            store.dispatch(getSearchResults(false));
            console.log(error);
        });
    }

    render() {
        return (
            <div style = {{minHeight: '90vh'}}>
                <Modify />
                <Sort />
                <Listing />
            </div>
        );
    }
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(Search);